import { render, staticRenderFns } from "./ModalCreateOrUpdateUltimateLearningOutcome.vue?vue&type=template&id=3bd474c6&"
import script from "./ModalCreateOrUpdateUltimateLearningOutcome.vue?vue&type=script&lang=js&"
export * from "./ModalCreateOrUpdateUltimateLearningOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports